import { useEffect, useState } from "react";
import SelectableButtons from "../../Components/Dropdown/SelectableButtons";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import { getGroups } from "../../Requests/optionDomain";
import { IDeltaHedgeAccountAggregateReportSearchParam } from "../../Interfaces/deltaHedgeAccounts";
import { packetErrorHandler } from "../../Utils/requestUtils";
import AggregateTable from "../../Tables/DeltaHedgeAccount/Aggregate/AggregateTable";
import FileDownloader from "../../Components/FileDownloader";
import { getAggregateExcel } from "../../Requests/deltaHedgeAccounts";

const Aggregate = () => {
  const [groups, setGroups] = useState([] as DropdownItem[]);
  const [searchParams, setSearchParams] = useState(
    {} as IDeltaHedgeAccountAggregateReportSearchParam
  );

  useEffect(() => {
    getGroups()
      .then((resp) => {
        setGroups(resp);
        setSearchParams({ groupId: resp[0].id });
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <div className="flex flex-row justify-between items-center w-full">
        <SelectableButtons
          label="گروه"
          name="groupId"
          options={groups}
          onChange={changeHandler}
          value={searchParams.groupId?.toString()}
          hideSelectAll
        />
        <FileDownloader getFile={getAggregateExcel} />
      </div>
      <AggregateTable searchParams={searchParams} />
    </div>
  );
};

export default Aggregate;
